import React from 'react';
import classnames from 'classnames';
import {
  Button,
  Form, FormControl,
} from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { FormRenderFieldType } from 'types/TextField';
import { InputFileProps } from 'types/InputFile';
import img from 'assets/img/folder.png';
import imgFile from 'assets/img/file.png';
import { IoIosClose } from 'react-icons/io';

function ImageProfileField( {
  value,
  validateTranslateValues,
  classNames = {},
  onChange,
  isInvalid,
  showErrors = true,
  meta,
  dropzoneOptions,
}: InputFileProps & FormRenderFieldType ) {
  const { t } = useTranslation();

  return (
    <Form.Group className={classnames( 'form-group', classNames.formGroup, {
      'is-invalid': isInvalid,
    } )}
    >
      <Dropzone
        {...dropzoneOptions}
        onDrop={( files ) => {
          if ( files && onChange ) {
            if ( dropzoneOptions?.multiple ) {
              if ( Array.isArray( value ) ) {
                onChange( [...value, ...files] );
              } else onChange( files );
            } else onChange( files[0] );
          }
        }}
      >
        {( { getRootProps, getInputProps } ) => (
          <div className="dropzone" {...getRootProps()}>
            <input {...getInputProps()} />

            <div className="p-5 bg--gray23 rounded text-center">
              <img src={img} alt="" height={48} />
              <h3 className="my-2">Arrastra y suelta o elige un archivo para subir</h3>
              <p className="m-0">Selecciona un archivo zip, imagen, PDF o documento de Microsoft Word.</p>
            </div>

            {value && (
              <div className="d-flex align-items-center mt-3 gap-2">
                <img src={imgFile} alt="" height={30} />
                <p className="text--bold m-0">
                  {Array.isArray( value ) ? value.map( ( item ) => item.name ).join( ', ' ) : value?.name || ''}
                </p>
                <Button
                  className="p-0"
                  variant="link"
                  onClick={( e ) => {
                    e.stopPropagation();
                    onChange?.( undefined );
                  }}
                >
                  <IoIosClose />
                </Button>
              </div>
            )}

            {showErrors
            && (
              <FormControl.Feedback type="invalid">
                {isInvalid ? t( meta?.error || meta?.submitError, validateTranslateValues ) || ' ' : ''}
              </FormControl.Feedback>
            )}
          </div>
        )}
      </Dropzone>
    </Form.Group>
  );
}

export default ImageProfileField;
